/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from './shared/toast/toast.component.ngfactory';
import * as i4 from '../../app/shared/toast/toast.component';
import * as i5 from '../../app/app.component';
import * as i6 from '../../app/shared/browser-events.service';
import * as i7 from '../../app/shared/toast/toast.service';
import * as i8 from '../../app/shared/modal/modal-placeholder.service';
import * as i9 from '../../app/shared/backend-events';
import * as i10 from '../../app/shared/preview-app.service';
import * as i11 from '../../app/shared/router-history.service';
import * as i12 from '../../app/shared/title.service';
import * as i13 from '../../app/shared/settings.service';
import * as i14 from '../../app/shared/http-client';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{toast:0}),i1.ɵqud(402653184,2,{modalPlaceholderRef:0}),
      i1.ɵqud(402653184,3,{appContentEl:0}),(_l()(),i1.ɵeld(0,[[3,0],['appContent',
          1]],(null as any),4,'section',[['class','app-content']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n    '])),(_l()(),i1.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(212992,(null as any),0,i2.RouterOutlet,[i2.ChildrenOutletContexts,i1.ViewContainerRef,
          i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵted((null as any),
          ['\n\n'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'toast',([] as any[]),
          (null as any),(null as any),(null as any),i3.View_ToastComponent_0,i3.RenderType_ToastComponent)),
      i1.ɵdid(49152,[[1,4]],0,i4.ToastComponent,[i1.ElementRef,i1.Renderer2],(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n\n'])),(_l()(),i1.ɵeld(16777216,
          [[2,3],['modalPlaceholder',1]],(null as any),0,'div',[['id','modal-placeholder']],
          (null as any),(null as any),(null as any),(null as any),(null as any)))],
      (_ck,_v) => {
        _ck(_v,6,0);
      },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-root',([] as any[]),
      [[2,'loading',(null as any)]],(null as any),(null as any),View_AppComponent_0,
      RenderType_AppComponent)),i1.ɵdid(114688,(null as any),0,i5.AppComponent,[i1.ElementRef,
      i6.BrowserEvents,i7.ToastService,i1.Renderer2,i8.ModalPlaceholderService,i9.BackendEvents,
      i10.PreviewApp,i11.RouterHistory,i12.TitleService,i13.SettingsService,i14.HttpClient,
      i2.Router],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).isLoading;
    _ck(_v,0,0,currVal_0);
  });
}
export const AppComponentNgFactory:i1.ComponentFactory<i5.AppComponent> = i1.ɵccf('app-root',
    i5.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvYXBwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvZS9hcHBzL2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9tbnQvZS9hcHBzL2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cy5BcHBDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8c2VjdGlvbiBjbGFzcz1cImFwcC1jb250ZW50XCIgI2FwcENvbnRlbnQ+XG4gICAgPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxuPC9zZWN0aW9uPlxuXG48dG9hc3Q+PC90b2FzdD5cblxuPGRpdiBpZD1cIm1vZGFsLXBsYWNlaG9sZGVyXCIgI21vZGFsUGxhY2Vob2xkZXI+PC9kaXY+IiwiPGFwcC1yb290PjwvYXBwLXJvb3Q+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs0Q0NBQTtVQUFBO1VBQUEsNENBQXlDO1VBQUEsYUFDckM7VUFBQTthQUFBO3NDQUFBO1VBQUEsZUFBK0IsdUNBQ3pCO1VBQUEsV0FFVjtVQUFBO2FBQUE7VUFBQSxlQUFlLHlDQUVmO1VBQUE7VUFBQTs7UUFMSTs7OztvQkNESjtNQUFBOzZCQUFBLFVBQUE7OztlQUFBO0lBQUE7O0lBQUE7SUFBQSxXQUFBLFNBQUE7Ozs7In0=



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/app.component.ngfactory.ts